import { enqueueSnackbar } from "notistack";
import fetchServer from "../controllers/fetchServer";
import { URLdecode } from "../utils/url";
import moment from "moment";

export function useTransactions() {
  const getAccountStatement = async ({
    setLoading,
    startDate,
    endDate,
    callback,
  }) => {
    const params = URLdecode();

    setLoading && setLoading(true);

    await fetchServer({
      method: "GET",
      url: `/payment/v2/transaction/transactionReport?startDate=${moment(
        startDate
      ).format("YYYY-MM-DD")}&endDate=${moment(endDate).format("YYYY-MM-DD")}`,
    })
      .then((res) => {
        if (res) {
          if (res.status === 200) {
            callback?.(res?.data?.data);
          } else {
            enqueueSnackbar(
              res?.data?.message ||
                res?.data?.error ||
                "Something went wrong. please try again later.",
              {
                variant: "error",
              }
            );
          }
        }
      })
      .catch((err) => {
        enqueueSnackbar("Something went wrong. please try again later.", {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading && setLoading(false);
      });
  };

  return {
    getAccountStatement,
  };
}
